import React from 'react';
import classNames from 'classnames';
import { Dropdown } from '@dotcom/crown-ui';
import { FontStyleProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

export const FontStyle = ({
  addClass = '',
  label,
  fonts,
  onChange,
  selectedFont,
  testId = 'font-style',
}: FontStyleProps): React.ReactElement => {
  const classes = classNames(styles['font-style'], addClass);

  const selectOptions = fonts.map((font) => ({ id: font.id, value: font.text, label: font.text, font: font.family }));

  return (
    <Dropdown
      className={classes}
      label={label}
      options={selectOptions}
      onChange={onChange}
      value={selectedFont}
      testId={testId}
      isCustomSelect
    />
  );
};
